<div class="effective" *ngIf="config.dataType !== type.Timestamp">{{ '有效值' }} : {{ config.effective }}</div>
<div class="effective" *ngIf="config.dataType === type.Timestamp"
  >{{ '有效值' }} : {{ config.effective | date: 'yyyy-MM-dd HH:mm:ss' }}</div
>
